import { Component, OnInit, HostBinding, ElementRef, Input, OnChanges, SimpleChanges } from '@angular/core';
import { numSequence } from '@app/shared/utils/num-sequence';

@Component({
  selector: 'app-skeleton-text',
  template: `
    <app-skeleton-loader
      *ngFor="let num of numSequence(count)"
      [width]="width"
      [height]="height"
      [className]="className"></app-skeleton-loader>
  `,
})
export class SkeletonTextComponent implements OnChanges {
  @Input() width = '100%';
  @Input() height = '10px';
  @Input() count = 1;
  @Input() className = 'my-12';

  numSequence = numSequence;

  constructor() {}

  ngOnChanges(changes: SimpleChanges): void {
    this.height = changes['height']?.currentValue;
    this.width = changes['width']?.currentValue;
    this.count = changes['count']?.currentValue;
  }
}
